import { render } from "./EditPanel.vue?vue&type=template&id=264dbe28&scoped=true"
import script from "./EditPanel.vue?vue&type=script&lang=js"
export * from "./EditPanel.vue?vue&type=script&lang=js"

import "./EditPanel.vue?vue&type=style&index=0&id=264dbe28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264dbe28"]])

export default __exports__